import { Autocomplete, TextField } from "@mui/material"
import React, { useCallback } from "react"

interface IProps {
  label: string
  value: string | null
  options: string[]
  onChange(newValue: string | null): void
}

export function SimpleStringAutocomplete({ label, value, options, onChange }: Readonly<IProps>): React.JSX.Element {
  const internalOnChange: (event: any, newValue: string | null) => void = useCallback(
    (event, newValue) => {
      onChange(newValue)
    },
    [onChange]
  )

  return (
    <Autocomplete
      fullWidth
      value={value}
      options={options ?? []}
      onChange={internalOnChange}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={label}
          fullWidth
          sx={{
            backgroundColor: "white",
          }}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  )
}
